import React, { useCallback, useState } from "react";
import { Row, Col } from "antd";

import { getEntities } from "../../modules/crudOperations";
import { parseDateTime } from "../../modules/consignmentFunctions";
import NotificationListTable from "../../components/notificationList/notificationListTable";
import NotificationListHeader from "../../components/notificationList/notificationListHeader";
import NotificationListFilter from "../../components/notificationList/notificationListFilter";

function NotificationList() {
  const [notifications, setNotifications] = useState();
  const loadNotifications = useCallback((parameters) => {
    getEntities(
      "notification/all",
      setNotifications,
      (c) => ({
        ...c,
        key: c.id,
        insertionDateTime: parseDateTime(c.insertionDateTime),
        changeDateTime: parseDateTime(c.changeDateTime),
        creator: c.creatorUser,
        changer: c.changerUser,
      }),
      parameters
    );
  }, []);

  const [showFilter, setShowFilter] = useState();
  const handleFilterClick = useCallback(() => {
    setShowFilter(!showFilter);
  }, [showFilter]);

  return (
    <Row>
      <Col>
        <NotificationListHeader
          showFilter={showFilter}
          onFilterClick={handleFilterClick}
        />
        <NotificationListFilter
          showFilter={showFilter}
          onSetShowFilter={setShowFilter}
          loadNotifications={loadNotifications}
        />
        <NotificationListTable
          notifications={notifications}
          loadNotifications={loadNotifications}
        />
      </Col>
    </Row>
  );
}

export default NotificationList;
